import React, { useEffect } from "react";
import { FloatingLabelContainer } from "../../components/FloatingLabel";
import { isUiEvent } from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import TagBox from 'devextreme-react/tag-box';

// Component styles
import classes from "./TagBoxWidget.module.scss";

export function TagBoxWidget(props) {
  const { ui, data, config, doAction, useFloatingLabel } = props;

  let widgetId = ui.id;
  let multiline = config ? config.Multiline : false;
  let tagActionId = config ? config.TagActionId : null;

  let content = data && data.content ? JSON.parse(data.content) : null;
  let currentValues = content ? content.CurrentItemIds : [];
  let selectionCandidates = (content ? content.SelectionCandidates : null) || (config ? config.SelectionCandidates : null);
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("TagBoxWidget data of " + ui.id + ": ", data);
  }, [data]);

  const valueChanged = async (args) => {
    if (!isUiEvent(args)) return;
    //console.log("TagBoxWidget valueChanged", args);
    let toRemove = args.previousValue.filter(x => !args.value.includes(x));
    if (toRemove.length !== 1) return;
    await doAction(tagActionId, toRemove[0]);
  };

  return (
    <FloatingLabelContainer condition={useFloatingLabel} widgetId={widgetId} hasContent={currentValues.length > 0} text={ui.label}>
      <TagBox
        id={widgetId}
        className={cn(classes.box, useFloatingLabel ? classes.withFloatingLabel : "", disabled ? classes.disabled : "")}
        items={selectionCandidates}
        multiline={multiline}
        openOnFieldClick={false}
        onValueChanged={(e) => valueChanged(e)}
        acceptCustomValue={false}
        searchEnabled={false}
        showSelectionControls={false}
        value={currentValues}
        valueExpr={"ItemId"}
        displayExpr={"DisplayData"}
        noDataText={"Type to search..."}
        focusStateEnabled={false}
        placeholder=""
        disabled={disabled}
        height={multiline ? "100%" : ui.controlHeight + "em"}
      />
    </FloatingLabelContainer>
  );
}

